import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { ActivatedRoute } from '@angular/router';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { CargueP, CargueService } from '../services/cargue_presupuesto.service';
import { log } from 'console';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
@Component({
    selector: 'app-cargue-presupuesto',
    templateUrl: './cargue-presupuesto.component.html',
    styleUrls: ['./cargue-presupuesto.component.scss'],
    styles: [
        `
    @media only screen and (max-width: 500px) {
        .card-body {
            flex-wrap: wrap
        }
        }
        `
    ]
})
export class CargueSegurosComponent implements OnInit {
    file: File;
    recordsToSend: number = 1000; //--> No de registros que se enviarán en cada request
    reader = new FileReader();
    isFileLoaded: boolean = false
    isProcesar: boolean = false
    textFileLoaded: String
    lastTextFileLoaded: String
    csvMatriz: string[] = [];
    csvHeader: string[] = [];
    parsedInfo: any[] = []
    incorrectInfo: any[] = []
    inputFile: HTMLInputElement
    mesAñoConcatenadoInicio: String
    mesAñoConcatenadoFin: String
    mesAñoConcatenadoPeriodo: String

    chosenYearHandler(normalizedYear: any) {
        const ctrlValue = this.cargueForm.get('selectedDate')?.value;
        ctrlValue.year(normalizedYear.year());
        this.cargueForm.get('selectedDate')?.setValue(ctrlValue);
        //console.log("Fecha seleccionada:", this.cargueForm.get('selectedDate')?.setValue(ctrlValue));
    }
    selectedDateChangedInicio(event: MatDatepickerInputEvent<Date, unknown>) {
        if (event.value) {
            const fechaSeleccionada = event.value;
            const dia = fechaSeleccionada.getDate().toString().padStart(2, '0'); // Obtener el día del mes como string de dos caracteres
            const mes = (fechaSeleccionada.getMonth() + 1).toString().padStart(2, '0'); // Obtener el mes como string de dos caracteres
            const año = fechaSeleccionada.getFullYear().toString(); // Obtener el año como string
            this.mesAñoConcatenadoInicio = dia + mes + año;
        }
    }

    selectedDateChangedFin(event: MatDatepickerInputEvent<Date, unknown>) {
        if (event.value) {
            const fechaSeleccionada = event.value;
            const dia = fechaSeleccionada.getDate().toString().padStart(2, '0'); // Obtener el día del mes como string de dos caracteres
            const mes = (fechaSeleccionada.getMonth() + 1).toString().padStart(2, '0'); // Obtener el mes como string de dos caracteres
            const año = fechaSeleccionada.getFullYear().toString(); // Obtener el año como string
            this.mesAñoConcatenadoFin = dia + mes + año;
        }
    }

    selectedDateChangedPeriodo(event: MatDatepickerInputEvent<Date, unknown>) {
        if (event.value) {
            const fechaSeleccionada = event.value;
            const dia = fechaSeleccionada.getDate().toString().padStart(2, '0'); // Obtener el día del mes como string de dos caracteres
            const mes = (fechaSeleccionada.getMonth() + 1).toString().padStart(2, '0'); // Obtener el mes como string de dos caracteres
            const año = fechaSeleccionada.getFullYear().toString(); // Obtener el año como string
            this.mesAñoConcatenadoPeriodo = año + mes + dia;  //--> Formato AAAAMMDD
        }
    }

    cargueForm: FormGroup = new FormGroup({
        periodo: new FormControl('', [Validators.required, Validators.pattern(/^.{4,6}$/)]
        ),
    })
    constructor(private notificationService: NotificationHelper,
        private activatedRoute: ActivatedRoute,
        private helpers: HelpersService,
        private cargueService: CargueService,

    ) {
        this.reader.addEventListener('load', (event) => {
            showSpinner()
            this.textFileLoaded = this.reader.result ? this.reader.result as string : "";
            this.csvMatriz = this.textFileLoaded.split(/\r\n|\n/)
            try {
                this.onLoadFile()
            } catch (error: any) {
                this.notificationService.errorMessage(error.message)
            }
            hideSpinner()
        });
        const data = this.activatedRoute.snapshot.data
        if (data.title) {
            this.helpers.setTitle(data.title);
        }
    }
    // Funciones utilitarias
    /* validarCamposNumericos(valor) {
        const patron = /^[0-9]+$/;
        return patron.test(valor);
    } */
    /* validarFecha(fecha) {
        var regexFecha = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/;
        return regexFecha.test(fecha);
    } */
    async onSelectFile(e: HTMLInputElement) {

        this.parsedInfo = []
        this.incorrectInfo = []

        showSpinner()
        //console.log('onSelectFile')
        this.inputFile = e
        const files = this.inputFile.files;
        if (files && files.length) {
            this.reader.readAsText(files[0]);
        } else {
            this.notificationService.errorMessage("No se seleccionó ningún archivo.");
        }

        // Enviar el lote a la API
        const res = await this.cargueService.eliminarArchivo('JA');
        //console.log(res);
        hideSpinner();
    }
    onLoadFile() {
        //console.log('onLoadFile-------')
        showSpinner();
        if (this.csvMatriz == undefined || this.csvMatriz.length <= 0) {
            throw new Error("Este archivo no contiene datos.");
        }
        //Sacar el primer registro (debe contener los encabezados)
        const shift = this.csvMatriz.shift();
        if (!shift) {
            throw new Error("Error eliminando encabezados")
        }
        //Obtenemos el header
        this.csvHeader = shift.replace(/"/g, '').toUpperCase().split(";");
        //console.log(this.csvHeader);
        if (!(this.csvHeader[0].toUpperCase().trim() === "PAIS" &&
            this.csvHeader[1].toUpperCase().trim() === "ALTERNATIVA" &&
            this.csvHeader[2].toUpperCase().trim() === "AGENCIA" &&
            this.csvHeader[3].toUpperCase().trim() === "CATEGORIA" &&
            this.csvHeader[4].toUpperCase().trim() === "LINEA" &&
            this.csvHeader[5].toUpperCase().trim() === "SUBLINEA" &&
            this.csvHeader[6].toUpperCase().trim() === "VENTA_OFERTA" &&
            this.csvHeader[7].toUpperCase().trim() === "CMV" &&
            this.csvHeader[8].toUpperCase().trim() === "ARMADO" &&
            this.csvHeader[9].toUpperCase().trim() === "FLETE" &&
            this.csvHeader[10].toUpperCase().trim() === "BODEGAJE" &&
            this.csvHeader[11].toUpperCase().trim() === "GARANTIA"
        )
        ) {
            throw new Error("Este archivo no tiene el formato requerido.")
        }
        if (this.csvMatriz.length <= 0) {
            throw new Error("El archivo tiene el formato, pero no tiene registros.");
        }

        this.csvMatriz.forEach((value, index) => {
            const split = value.replace(/"/g, '').toUpperCase().split(";");
            //console.log(split.length);
            if (split.length == 12) {
                const item: CargueP = {
                    PAIS: split[0] ? split[0] : "",
                    ALTERNATIVA: split[1] ? split[1] : "",
                    AGENCIA: split[2] ? split[2] : "",
                    CATEGORIA: split[3] ? split[3] : "",
                    LINEA: split[4] ? split[4] : "",
                    SUBLINEA: split[5] ? split[5] : "",
                    VENTA_OFERTA: split[6] ? split[6] : "",
                    CMV: split[7] ? split[7] : "",
                    ARMADO: split[8] ? split[8] : "",
                    FLETE: split[9] ? split[9] : "",
                    BODEGAJE: split[10] ? split[10] : "",
                    GARANTIA: split[11] ? split[11] : "",
                }
                this.parsedInfo.push(item);
                /* if (item.cliente && this.validarCamposNumericos(item.cuenta) && this.validarCamposNumericos(item.factura)) {
                this.parsedInfo.push(item);
                } else {
                this.incorrectInfo.push(item)
                } */
            }
        }
        );

        if (this.incorrectInfo.length > 0) {
            this.notificationService.warningMessage(`Se encontraron ${this.incorrectInfo.length} registros no válidos.`)
        } else if (this.parsedInfo.length > 0) {
            this.notificationService.infoMessage(`Se encontraron ${this.parsedInfo.length} registros válidos.`)
            this.enableSendButton()
        }
        hideSpinner()
    }

    disableButtonAndDeleteLoadedInfo() {
        this.parsedInfo = [];
        this.csvMatriz = [];
        this.csvHeader = [];
        this.isFileLoaded = false;
        this.incorrectInfo = []
    }

    enableSendButton() {
        this.isFileLoaded = true;
    }
    ngOnInit(): void {

    }
    onResetForm() {
        this.cargueForm.reset();
    }

    ConvertToCSV(objArray, headerList) {
        let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        let str = '';
        let row = '';
        for (let index in headerList) {
            row += headerList[index] + ';';
        }
        row = row.slice(0, -1);
        str += row + '\r\n';

        for (let i = 0; i < array.length; i++) {
            let line = '';

            for (let index in headerList) {
                let head = headerList[index];
                line += array[i][head] + ';';
            }

            str += line + '\r\n';
        }
        return str;
    }

    doFile(data, filename = 'data') {
        let csvData = this.ConvertToCSV(data, Object.keys(data[0]));
        let dataFile = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        return dataFile
    }

    /* async onSubmit(): Promise<void> {
        if (this.parsedInfo.length > 0) {
        const divisor = this.parsedInfo.length / this.recordsToSend;
        let dividedData: any[] = [];
    
        for (let i = 0; i < divisor; i++) {
            const element = this.parsedInfo.slice(i * this.recordsToSend, (i + 1) * this.recordsToSend);
            dividedData.push(element)
        }
        let contador= 1;
        for(let element of   dividedData){
            let porcentaje = Math.round((contador / dividedData.length) * 100);
            showSpinner(`Cargando Registros  ${porcentaje} %...`);
            try {
            
            const res = await this.cargueService.cargue('JA', element);
            
            if(!res.success) {
                this.notificationService.errorMessage(res.message);
                hideSpinner();
                return;
            }
            } catch (error) {
            console.error(error);
            this.notificationService.errorMessage("Ocurrio un error desconocido.")
            hideSpinner();
            return;
            }
            contador++;
        }
        hideSpinner()
        this.notificationService.successMessage("Cargo correctamente")
        this.isFileLoaded = false;
        location.reload()
        } else {
        this.notificationService.infoMessage("No hay nada que enviar")
        }
        
        this.inputFile.value = ""
    } */

    async onSubmit(): Promise<void> {
        if (this.parsedInfo.length > 0) {
            let totalRecords = this.parsedInfo.length;
            let processedRecords = 0; // Contador de registros procesados

            while (processedRecords < totalRecords) {
                // Extraer un lote de tamaño máximo `recordsToSend`
                const batch = this.parsedInfo.slice(processedRecords, processedRecords + this.recordsToSend);

                // Calcular porcentaje de progreso
                let porcentaje = Math.round(((processedRecords + batch.length) / totalRecords) * 100);
                showSpinner(`Cargando registros ${porcentaje}%...`);

                try {
                    // Enviar el lote a la API
                    const res = await this.cargueService.cargue('JA', batch);

                    if (!res.success) {
                        this.notificationService.errorMessage(res.message);
                        hideSpinner();
                        return; // Terminar en caso de error
                    }
                } catch (error) {
                    //console.error(error);
                    this.notificationService.errorMessage("Ocurrió un error desconocido.");
                    hideSpinner();
                    return; // Terminar en caso de error
                }

                // Incrementar el contador de registros procesados
                processedRecords += batch.length;
            }

            hideSpinner();
            this.notificationService.successMessage("Carga completada correctamente.");
            this.isFileLoaded = false;
            this.isProcesar = true;
        } else {
            this.notificationService.infoMessage("No hay nada que enviar.");
        }

        // Limpiar el input file
        this.inputFile.value = "";
    }

    async procesarArchivo() {
        showSpinner(`Procesando Reporte 5%...`);
        // Validar si se han seleccionado los periodos requeridos
        if (!(this.mesAñoConcatenadoPeriodo && this.mesAñoConcatenadoInicio && this.mesAñoConcatenadoFin)) {
            this.notificationService.errorMessage("No se ha seleccionado un periodo");
            hideSpinner();
            return;
        }

        // Iniciar el procesamiento del archivo
        const result = await this.cargueService.procesarArchivo(
            'JA', this.mesAñoConcatenadoPeriodo, this.mesAñoConcatenadoInicio, this.mesAñoConcatenadoFin
        );

        if (!result) {
            this.notificationService.infoMessage("No se ha conseguido registros para ese periodo");
            hideSpinner();
            return;
        }

        // 🔥 PROGRESO BASADO EN TIEMPO 🔥
        let tiempoTranscurrido = 0; // En minutos
        let tiempoTotal = 25; // Minutos totales del proceso

        let intervalo = setInterval(() => {
            tiempoTranscurrido++;

            // Calcular el porcentaje basado en el tiempo y redondear a múltiplos de 25%
            let porcentaje = Math.ceil((tiempoTranscurrido / tiempoTotal) * 100 / 25) * 25;

            // Actualizar el spinner con el progreso
            showSpinner(`Procesando Reporte ${porcentaje}%...`);

            // Cuando se alcance el 100% (25 min), detener la actualización
            if (porcentaje == 100) {
                clearInterval(intervalo);
                hideSpinner();
                this.notificationService.successMessage("Archivo procesado correctamente");
                location.reload();
            }
        }, 60000); // Se ejecuta cada 1 minuto (60,000 ms)
    }

}